//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createTransitions.js
var e = {
	easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
	easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
	easeIn: "cubic-bezier(0.4, 0, 1, 1)",
	sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, t = {
	shortest: 150,
	shorter: 200,
	short: 250,
	standard: 300,
	complex: 375,
	enteringScreen: 225,
	leavingScreen: 195
};
function n(e) {
	return `${Math.round(e)}ms`;
}
function r(e) {
	if (!e) return 0;
	let t = e / 36;
	return Math.min(Math.round((4 + 15 * t ** .25 + t / 5) * 10), 3e3);
}
function i(i) {
	let a = {
		...e,
		...i.easing
	}, o = {
		...t,
		...i.duration
	};
	return {
		getAutoHeightDuration: r,
		create: (e = ["all"], t = {}) => {
			let { duration: r = o.standard, easing: i = a.easeInOut, delay: s = 0, ...c } = t;
			if (process.env.NODE_ENV !== "production") {
				let n = (e) => typeof e == "string", a = (e) => !Number.isNaN(parseFloat(e));
				!n(e) && !Array.isArray(e) && console.error("MUI: Argument \"props\" must be a string or Array."), !a(r) && !n(r) && console.error(`MUI: Argument "duration" must be a number or a string but found ${r}.`), n(i) || console.error("MUI: Argument \"easing\" must be a string."), !a(s) && !n(s) && console.error("MUI: Argument \"delay\" must be a number or a string."), typeof t != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join("\n")), Object.keys(c).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(c).join(",")}].`);
			}
			return (Array.isArray(e) ? e : [e]).map((e) => `${e} ${typeof r == "string" ? r : n(r)} ${i} ${typeof s == "string" ? s : n(s)}`).join(",");
		},
		...i,
		easing: a,
		duration: o
	};
}
//#endregion
export { i as default };

//# sourceMappingURL=index94.js.map